<div class="partner-legal-documents-body">
    <!--Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>
    <!--Body-->
    <div class="flex flex-row" style="margin-top: 20px;">
        <div>
            <div class="partner-legal-documents-menu-label">Store documents</div>
            <div>Upon expiry, we will automatically send you an email to upload your new document.</div>
        </div>
        <div style="margin-left: auto">
            <button [disabled]="(activeDocumentMenuItem===menuLevel3Enum.BusinessPermit && !businessPermitOnReview.Id) || (activeDocumentMenuItem===menuLevel3Enum.BIR2303 && !BIR2303OnReview.Id)"
                    class="p-button-outlined" style="width: 123px; height: 45px;" (click)="showStatusPopup=true;" pButton label="View Status"></button>
        </div>
        <div style="margin-left: 20px;">
            <button *ngIf="activeDocumentMenuItem === menuLevel3Enum.BusinessPermit" [disabled]="businessPermitOnReview.StatusId !== legalDocumentStatusEnum.Active && businessPermitOnReview.Id" class="btn-darkblue" style="width: 123px; height: 45px;" (click)="showLegalDocumentUpdateSidebar=true;" pButton label="Update"></button>
            <button *ngIf="activeDocumentMenuItem === menuLevel3Enum.BIR2303" [disabled]="BIR2303OnReview.StatusId !== legalDocumentStatusEnum.Active && BIR2303OnReview.Id" class="btn-darkblue" style="width: 123px; height: 45px;" (click)="showLegalDocumentUpdateSidebar=true;" pButton label="Update"></button>
        </div>
    </div>
    <div *ngIf="activeDocumentMenuItem === menuLevel3Enum.BusinessPermit">
        <div class="partner-legal-documents-input-group-label">Business Permit</div>

        <div class="flex flex-row">
            <div style="width: 285px; margin-right: 40px;">
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Issue Date</div>
                    <p-calendar [(ngModel)]="businessPermit.DocumentIssueDate" placeholder="mm/dd/yyyy" [inputStyle]="{'background': '#F2F5F7'}" [disabled]="true"></p-calendar>
                </div>
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Expiration Date</div>
                    <p-calendar [(ngModel)]="businessPermit.DocumentExpirationDate" placeholder="mm/dd/yyyy" [inputStyle]="{'background': '#F2F5F7'}" [disabled]="true"></p-calendar>
                </div>
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Document Number</div>
                    <input [(ngModel)]="businessPermit.DocumentNumber" placeholder="Enter here" style="background: #F2F5F7;" [disabled]="true" type="text" pInputText />
                </div>
            </div>

            <div *ngIf="businessPermit.DocumentImageUrl">
                <p-image [src]="businessPermit.DocumentImageUrl" alt="Image" width="450" [preview]="true"></p-image>
            </div>
        </div>
    </div>
    <div *ngIf="activeDocumentMenuItem === menuLevel3Enum.BIR2303">
        <div class="partner-legal-documents-input-group-label">BIR 2303</div>

        <div class="flex flex-row">
            <div style="width: 285px; margin-right: 40px;">
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Issue Date</div>
                    <p-calendar [(ngModel)]="BIR2303.DocumentIssueDate" placeholder="mm/dd/yyyy" [inputStyle]="{'background': '#F2F5F7'}" [disabled]="true"></p-calendar>
                </div>
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Expiration Date</div>
                    <p-calendar [(ngModel)]="BIR2303.DocumentExpirationDate" placeholder="mm/dd/yyyy" [inputStyle]="{'background': '#F2F5F7'}" [disabled]="true"></p-calendar>
                </div>
                <div class="partner-legal-documents-input-item">
                    <div class="partner-legal-documents-input-label">Document Number</div>
                    <input [(ngModel)]="BIR2303.DocumentNumber" placeholder="Enter here" style="background: #F2F5F7;" [disabled]="true" type="text" pInputText />
                </div>
            </div>

            <div *ngIf="BIR2303.DocumentImageUrl">
                <p-image [src]="BIR2303.DocumentImageUrl" alt="Image" width="450" [preview]="true"></p-image>
            </div>
        </div>
    </div>

    <p-dialog [(visible)]="showStatusPopup" [modal]="true" [draggable]="false" [style]="{width: '600px'}">
        <ng-template pTemplate="header">
            <div class="partner-documents-updated-header">Your update was submitted</div>
        </ng-template>

        <div *ngIf="activeDocumentMenuItem===menuLevel3Enum.BusinessPermit">
            <div class="flex flex-row" style="margin-bottom: 40px;">
                <div class="partner-documents-status-field-margin">
                    <div class="partner-legal-documents-status-darkblue"></div>
                    <div class="partner-documents-status-label">We have received your update</div>
                </div>
                <div class="partner-documents-status-field-margin">
                    <div class="partner-legal-documents-status-field" [ngClass]="{
                        'partner-legal-documents-status-darkblue': businessPermitOnReview.StatusId === legalDocumentStatusEnum.OnReview || businessPermitOnReview.StatusId === legalDocumentStatusEnum.Active ||
                         businessPermitOnReview.StatusId === legalDocumentStatusEnum.Rejected}"></div>
                    <div *ngIf="businessPermitOnReview.StatusId === legalDocumentStatusEnum.OnReview || businessPermitOnReview.StatusId === legalDocumentStatusEnum.Active || 
                         businessPermitOnReview.StatusId === legalDocumentStatusEnum.Rejected" class="partner-documents-status-label">Working on it</div>
                </div>
                <div>
                    <div class="partner-legal-documents-status-field" [ngClass]="{
                        'partner-legal-documents-status-green': businessPermitOnReview.StatusId === legalDocumentStatusEnum.Active,
                         'partner-legal-documents-status-red': businessPermitOnReview.StatusId === legalDocumentStatusEnum.Rejected}"></div>
                    <div *ngIf="businessPermitOnReview.StatusId === legalDocumentStatusEnum.Active" class="partner-documents-status-label">Update Approved!</div>
                    <div *ngIf="businessPermitOnReview.StatusId === legalDocumentStatusEnum.Rejected" class="partner-documents-status-label" style="color: #EB4236">Sorry your update was rejected</div>
                </div>
            </div>
            <div class="partner-documents-updated-label">Updated Legal Document</div>
            <div>Business Permit</div>
            <div class="flex flex-row">
                <div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Issue Date</div>
                        <div class="partner-documents-updated-field-value">{{businessPermitOnReview.IssueDateStr}}</div>
                    </div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Expiration Date</div>
                        <div class="partner-documents-updated-field-value">{{businessPermitOnReview.ExpiredDateStr}}</div>
                    </div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Document number</div>
                        <div class="partner-documents-updated-field-value">{{businessPermitOnReview.DocumentNumber}}</div>
                    </div>
                </div>
                <div style="margin-left: auto; margin-right: 30px">
                    <p-image appendTo="body" [src]="businessPermitOnReview.DocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
                </div>
            </div>
        </div>

        <div *ngIf="activeDocumentMenuItem===menuLevel3Enum.BIR2303">
            <div class="flex flex-row" style="margin-bottom: 40px;">
                <div class="partner-documents-status-field-margin">
                    <div class="partner-legal-documents-status-darkblue"></div>
                    <div class="partner-documents-status-label">We have received your update</div>
                </div>
                <div class="partner-documents-status-field-margin">
                    <div class="partner-legal-documents-status-field" [ngClass]="{
                        'partner-legal-documents-status-darkblue': BIR2303OnReview.StatusId === legalDocumentStatusEnum.OnReview || BIR2303OnReview.StatusId === legalDocumentStatusEnum.Active || 
                         BIR2303OnReview.StatusId === legalDocumentStatusEnum.Rejected}"></div>
                    <div *ngIf="BIR2303OnReview.StatusId === legalDocumentStatusEnum.OnReview || BIR2303OnReview.StatusId === legalDocumentStatusEnum.Active || 
                         BIR2303OnReview.StatusId === legalDocumentStatusEnum.Rejected" class="partner-documents-status-label">Working on it</div>
                </div>
                <div>
                    <div class="partner-legal-documents-status-field" [ngClass]="{
                        'partner-legal-documents-status-green': BIR2303OnReview.StatusId === legalDocumentStatusEnum.Active,
                        'partner-legal-documents-status-red': BIR2303OnReview.StatusId === legalDocumentStatusEnum.Rejected}"></div>
                    <div *ngIf="BIR2303OnReview.StatusId === legalDocumentStatusEnum.Active" class="partner-documents-status-label">Update Approved!</div>
                    <div *ngIf="BIR2303OnReview.StatusId === legalDocumentStatusEnum.Rejected" class="partner-documents-status-label" style="color: #EB4236">Sorry your update was rejected</div>
                </div>
            </div>
            <div class="partner-documents-updated-label">Updated Legal Document</div>
            <div>BIR 2303</div>
            <div class="flex flex-row">
                <div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Issue Date</div>
                        <div class="partner-documents-updated-field-value">{{BIR2303OnReview.IssueDateStr}}</div>
                    </div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Expiration Date</div>
                        <div class="partner-documents-updated-field-value">{{BIR2303OnReview.ExpiredDateStr}}</div>
                    </div>
                    <div class="partner-documents-updated-field">
                        <div class="partner-documents-updated-field-label">Document number</div>
                        <div class="partner-documents-updated-field-value">{{BIR2303OnReview.DocumentNumber}}</div>
                    </div>
                </div>
                <div style="margin-left: auto; margin-right: 30px">
                    <p-image appendTo="body" [src]="BIR2303OnReview.DocumentImageUrl" alt="Image" width="250" [preview]="true"></p-image>
                </div>
            </div>
        </div>


    </p-dialog>
</div>

<legal-documents-update *ngIf="showLegalDocumentUpdateSidebar" [store]="store" [activeDocumentMenuItem]="activeDocumentMenuItem" [onHide]="handleUpdateLegalDocsHide"></legal-documents-update>
<p-toast position="top-right"></p-toast>
